import { Star } from "lucide-react";
import { useLandingCopy } from "./LandingContext";
import { AppStoreButton } from "./AppStoreButton";

/**
 * Always-visible App Store CTA pinned to the bottom of the screen on mobile —
 * the single biggest conversion lever for cold ad traffic. Hidden on desktop,
 * where the nav CTA stays in view. Carries the App Store rating as a compact
 * trust signal next to the hint text.
 */
export function StickyCta() {
  const copy = useLandingCopy();

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/95 px-4 py-3 backdrop-blur-lg lg:hidden">
      <div className="mx-auto flex max-w-md items-center justify-between gap-3">
        <div className="min-w-0 leading-tight">
          <span className="block text-sm font-medium text-foreground">{copy.stickyHint}</span>
          <span className="mt-0.5 flex items-center gap-1 text-xs text-muted-foreground">
            <Star className="h-3 w-3 fill-current text-accent" aria-hidden="true" />
            <span className="font-semibold text-foreground">{copy.rating.value}</span>
            {copy.rating.label}
          </span>
        </div>
        <AppStoreButton
          location="sticky"
          label={copy.ctaShort}
          variant="button"
          className="min-h-[44px] flex-shrink-0 px-5 py-3 text-sm"
        />
      </div>
    </div>
  );
}
